module.exports = __webpack_public_path__ + "static/media/home-card5.308b3030.png";